<template>
  <div v-if="localShow" class="modal-overlay" @click="closeModal">
    <div class="modal-dialog" @click.stop>
      <BaseDialog
        :title="'Update Dataset'"
        :footerButtons="['Save']"
        @cancel="closeModal"
        @footer-click="handleFooterClick"
      >
        <div class="settings__control-group">
          <label>Name</label>
          <input
            v-model="name"
            class="select"
            type="text"
          >
        </div>
        <div class="settings__control-group">
          <label>Description</label>
          <textarea
            v-model="description"
            rows="4"
            cols="50"
          />
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import BaseDialog from '@/components/DilaogTemplate/BaseDialog.vue';

export default {
  name: 'DatasetUpdateModal',
  components: {
    BaseDialog,
  },
  props: {
    dataset: {
      type: Object,
      default: () => {},
    },
  },
  emits: {
    'edit-dataset': null,
  },
  data() {
    return {
      name: '',
      description: '',
      localShow: false,
    };
  },
  watch: {
    dataset: {
      deep: true,
      handler(d) {
        if (d) {
          this.name = d.name;
          this.description = d.description;
        }
      },
    },
  },
  methods: {
    showModal() {
      this.localShow = true;
    },
    closeModal() {
      this.name = "";
      this.description = "";
      this.localShow = false;
    },
    handleFooterClick(buttonLabel) {
      if (String(buttonLabel || '').toLowerCase() === 'save') {
        this.apply();
      }
    },
    apply() {
      if (this.name) {
        this.$emit('edit-dataset', {
          name: this.name, description: this.description, dataset_id: this.dataset.id, docker_task_id: this.dataset.docker_task_id,
        });
      }
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.modal-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

